import { Filters } from 'shared/types/filters';

export function hasTwoOfficeTypes(filters: Filters): boolean {
  return filters.officeType.length === 2;
}
